import { useTranslation } from 'next-i18next/pages'
import { Heading, TextAndMedia, StepList } from '@boltenergy-be/design-system'
import { OfferingSectionProps } from './types'
import { useMemo } from 'react'
import { I18nUSP } from 'types/i18n'

const BoltOffering = ({ title, showMediaOnMobile = true, overlay, steps, customImage, ...containerProps }: OfferingSectionProps) => {
  // i18n
  const { t } = useTranslation('common')

  // Constants
  const stepsToDisplay = useMemo<Array<I18nUSP>>(() => {
    if (steps?.length) return steps

    return t(($) => $.usps, { returnObjects: true })
  }, [steps, t])

  return (
    <TextAndMedia
      {...{ showMediaOnMobile }}
      title={title || t(($) => $.offering.title)}
      media={{
        type: 'image',
        props: { publicId: customImage || 'website/pricing/kris', width: 512, height: 450, alt: t(($) => $.offering.altKris) },
        overlay
      }}
      {...containerProps}
    >
      <StepList size="large">
        {stepsToDisplay.map(({ key, title, description }) => (
          <li key={`usp-${key}`}>
            <div className="flex-col gap-100">
              <Heading as="h2" variant="h4" serif>
                {title}
              </Heading>
              <p>{description}</p>
            </div>
          </li>
        ))}
      </StepList>
    </TextAndMedia>
  )
}

export default BoltOffering
